import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-etkisinin-suresi-ne-kadar-kalicidir/page.tsx");
